import React from 'react'
import CohabitantDetails from "./CohabitantDetails";
import Table from 'react-bootstrap/Table'

const CohabitantsList = (props) => {
  const cohabitants = props.cohabitants
  return (
    <>
      <h4 className="text-center">Cohabitant Details</h4>

      <Table bordered className='border-dark'>
        <thead>
          <tr>
            <td className="text-center"><u>First name</u></td>
            <td className="text-center"><u>Last name</u></td>
            <td className="text-center"><u>Age</u></td>
            <td className="text-center"><u>Date of birth</u></td>
            <td className="text-center"><u>Relation</u></td>
          </tr>
        </thead>
        {cohabitants.map(
          ({ first_name, last_name, date_of_birth, relation, id }, i) => (
            <CohabitantDetails
              key={i}
              id={id}
              first_name={first_name}
              last_name={last_name}
              date_of_birth={date_of_birth}
              relation={relation}
              deleteCohabitant={props.deleteCohabitant}
              currentUser={props.currentUser}
            />
          )
        )}
      </Table>
    </>
  )
}

export default CohabitantsList